import React from 'react';

const OPCIONES_PCT = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

/**
 * Input de porcentaje de bateria sincronizado con un select predefinido (0-100 cada 5%).
 * Props:
 *   id       - id para el <input>, enlaza con el <label> externo
 *   label    - texto del label
 *   value    - valor string controlado (0-100)
 *   onChange - callback(newValue: string)
 */
function PorcentajeBateriaInput({ id, label, value, onChange }) {
  const numVal = value === '' ? NaN : Number(value);
  // El select muestra la opcion si el valor es multiplo de 5 entre 0-100; si no, muestra placeholder
  const selectVal = !isNaN(numVal) && OPCIONES_PCT.includes(numVal) ? String(numVal) : '';

  return (
    <div className="input">
      <label htmlFor={id}>{label}</label>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          id={id}
          type="number"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Ej: 80"
          min={0}
          max={100}
          style={{ flex: 1 }}
        />
        <select
          aria-label={"Seleccionar " + label}
          value={selectVal}
          onChange={(e) => onChange(e.target.value)}
          style={{ flexShrink: 0 }}
        >
          <option value="">-- % --</option>
          {OPCIONES_PCT.map(o => (
            <option key={o} value={String(o)}>{o} %</option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default PorcentajeBateriaInput;

